const host = "https://ga.viabber.com"
// const host = "https://api-google-analytic.herokuapp.com"
// const host = "http://localhost:8000"

export default host;